module.exports = __webpack_public_path__ + "regular-17bd668fe421181c8bcd.svg";